export default {
  nav: {
    home: "Inicio",
    engines: "Motores",
    transmissions: "Transmisiones",
    bodyParts: "Piezas de carrocería",
    testimonials: "Testimonios",
    contact: "Contáctanos",
    getQuote: "Solicitar presupuesto",
    menu: "Abrir menú",
  },
  banner: {
    text: "GRAN REBAJA AHORA — Hasta 30% DE DESCUENTO en motores, transmisiones y piezas de carrocería seleccionados. Envío disponible en toda Australia.",
  },
  hero: {
    badge: "De confianza desde 2005",
    title1: "Motores usados de calidad y",
    titleHighlight: "Transmisiones",
    desc: "{{siteName}} es tu tienda integral de repuestos usados, nuevos y de posventa, con envío a toda Australia. Especialistas en los SUV y pick-ups más populares del mercado australiano.",
    contact: "Contáctanos",
    browse: "Ver motores",
  },
  about: {
    f1title: "Empresa familiar",
    f1text: "{{siteName}} es un negocio familiar de Darwin construido sobre la confianza, el trabajo duro y el cuidado genuino por cada cliente que atendemos.",
    f2title: "Reputación",
    f2text: "Disfrutamos de una sólida reputación construida sobre la integridad, la equidad y el conocimiento técnico en piezas usadas, nuevas y de posventa.",
    f3title: "Lo que hacemos",
    f3text: "Somos tu tienda integral de repuestos usados, nuevos y de posventa, respaldados por un taller especializado de servicio y reparación.",
    f4title: "Altamente cualificados",
    f4text: "Nuestros técnicos experimentados usan los últimos programas de diagnóstico y escáneres para ayudarte a evitar costes de reparación innecesarios.",
    stockLabel: "Lo que tenemos en stock",
    modelsTitle: "Modelos populares que cubrimos",
    modelsDesc: "Nos centramos en los pick-ups y SUV australianos más vendidos para que consigas la pieza correcta, rápido.",
  },
  why: {
    promise: "Nuestra promesa",
    title: "Por qué elegirnos",
    w1title: "Calidad",
    w1text: "Tranquilidad sabiendo que has recibido una pieza y un servicio de alta calidad, en cada ocasión.",
    w2title: "Ahorro",
    w2text: "Conserva más dinero en tu bolsillo con nuestros excelentes descuentos en todas las piezas, nuevas y usadas.",
    w3title: "Garantía",
    w3text: "Las piezas nuevas incluyen 12 meses de garantía y las usadas 3 meses de garantía.",
    w4title: "Envío",
    w4text: "Los artículos pequeños se envían de un día para otro, y los más grandes en 1 a 3 días en toda Australia.",
    missionTitle: "Nuestra misión",
    missionText: "Brindarte, a ti, a nuestros clientes y a la comunidad, un servicio al cliente de clase mundial. Aspiramos a lograr la más alta calidad en todo lo que hacemos para servirte mejor — a través de nuestros cuatro pilares de valor: Familia, Impulso, Innovación y Calidad.",
    valuesTitle: "Nuestros valores",
    v1label: "Familia",
    v1text: "Somos un solo equipo que se preocupa por nuestros clientes, nuestra gente y nuestros proveedores.",
    v2label: "Impulso",
    v2text: "Nos esforzamos por lo mejor en lo que hacemos, con una verdadera pasión por el éxito.",
    v3label: "Innovación",
    v3text: "Pensamos fuera de lo común y trabajamos duro para mejorar continuamente.",
    v4label: "Calidad",
    v4text: "Nos esforzamos por hacerlo bien a la primera, en cada ocasión.",
    t1text: "Servicio excelente. Resolvieron el trabajo el mismo día y se comunicaron conmigo todo el tiempo — ¡y a un precio excelente!",
    t1name: "Nico A.",
    t1loc: "Darwin",
    t2text: "Encontré exactamente el motor que necesitaba para mi HiLux. Amables, honestos y muy expertos en pick-ups australianos. Muy recomendables.",
    t2name: "Chris N.",
    t2loc: "Palmerston",
    t3text: "Muy serviciales, justos y honestos, con piezas usadas de calidad de todos los modelos populares. ¡Un gran aprobado!",
    t3name: "Stephen C.",
    t3loc: "Darwin",
    t4text: "Llegué con problemas desconocidos y estos chicos me pusieron en marcha rápidamente. Servicio fantástico.",
    t4name: "Armand D.",
    t4loc: "Katherine",
  },
  brand: {
    strip: "Piezas para todas las principales marcas",
  },
  cta: {
    title: "¿Buscas una pieza?",
    desc: "Cuéntanos qué necesitas y nuestro equipo la conseguirá para ti. Enviamos a toda Australia desde nuestro taller en Winnellie, Darwin.",
    request: "Solicitar presupuesto",
  },
  footer: {
    brandDesc: "La fuente de confianza de Australia para motores usados, transmisiones y piezas de carrocería de calidad. De propiedad familiar y centrada en los pick-ups y SUV australianos más populares.",
    quickLinks: "Enlaces rápidos",
    company: "Empresa",
    getInTouch: "Ponte en contacto",
    monFri: "Lun - Vie: 8:00 - 17:00",
    copyright: "© Copyright {{year}} {{siteName}}. Todos los derechos reservados.",
    disclaimer: "{{siteName}} es un especialista independiente en piezas y servicios.",
  },
  page: {
    enginesSubtitle: "Motores usados, nuevos y reconstruidos de calidad para todas las marcas y modelos – europeos, japoneses y americanos. Cada motor es inspeccionado, sellado y suministrado con garantía.",
    transmissionsSubtitle: "Transmisiones automáticas y manuales, usadas y nuevas, para todas las marcas y modelos – europeas, japonesas y americanas. Cada caja es inspeccionada, probada y suministrada con garantía.",
    bodyPartsSubtitle: "Paneles de carrocería, parachoques, espejos, luces y molduras usados y de posventa para todas las marcas y modelos. Paneles rectos, precios competitivos con garantía.",
  },
  grid: {
    ourStock: "Nuestro stock",
    itemsInStock: "{{count}} artículos en stock",
    shipping: "Envío a toda Australia",
    price: "Precio",
    enquire: "Consultar ahora",
    searchPlaceholder: "Buscar por marca, modelo o nombre de pieza...",
    allMakes: "Todas las marcas",
    allModels: "Todos los modelos",
    noResults: "Ninguna pieza coincide con tu búsqueda. Prueba con otra marca o modelo.",
    clearFilters: "Limpiar filtros",
  },
  availability: {
    badge: "Actualización de stock",
    title: "Usado y nuevo {{category}}",
    text: "Tenemos motores, transmisiones y piezas de carrocería para todas las marcas y modelos. Ofrecemos una amplia gama de motores, transmisiones y piezas de carrocería para coches europeos, japoneses, canadienses y americanos. Todas las piezas son inspeccionadas y cumplen los requisitos de calidad a los que están sujetas; cada artículo está sellado y lleva una marca especial. Todas las piezas usadas incluyen una garantía de calidad a largo plazo. Si tienes dudas sobre la elección de tu motor, transmisión o pieza de carrocería, contacta con nuestro equipo – estaremos encantados de responder tus preguntas y darte un asesoramiento completo. {{siteName}} – una búsqueda cómoda de piezas usadas y nuevas, con entrega rápida en 1–3 días laborables tras la recepción del pago.",
    cta: "Contáctanos",
  },
  request: {
    badge: "¿Falta una pieza?",
    title: "¿No encuentras la pieza que necesitas?",
    text: "{{siteName}} consigue cada semana motores, transmisiones y piezas de carrocería difíciles de encontrar. Indícanos marca, modelo y año — si hoy no está en stock, nuestro equipo la localizará y te responderá rápido.",
    cta: "Solicitar una pieza",
  },
  partsWeSource: {
    badge: "Pedido especial",
    title: "Piezas que conseguimos",
    desc: "¿No ves lo que buscas? {{siteName}} localiza cada semana piezas difíciles de encontrar — desde ECUs y cajas de ordenador raras hasta esas piezas únicas que nadie más tiene en stock.",
    ecuTitle: "ECUs y unidades de control",
    ecuText: "Módulos de control de motor, transmisión y carrocería, programados y probados en tu vehículo.",
    computerBoxTitle: "Cajas de ordenador",
    computerBoxText: "Cajas de ordenador de gestión del motor y módulos cableados para pick-ups, SUV y más.",
    hardToFindTitle: "Piezas difíciles de encontrar",
    hardToFindText: "Molduras raras, paneles descontinuados y piezas especiales localizadas a través de nuestra red nacional.",
    cta: "Solicitar una pieza",
  },
  contact: {
    badge: "Ponte en contacto",
    title: "Contáctanos",
    desc: "¿Tienes una pieza en mente? Envíanos una consulta y nuestro equipo te responderá puntualmente. Enviamos a toda Australia desde Winnellie, Darwin NT 0820.",
    sendEnquiry: "Enviar una consulta",
    formDesc: "Rellena el formulario y nos pondremos en contacto contigo en breve.",
    prefill: "Hemos pre-rellenado la pieza sobre la que consultas. Solo añade tus datos y cualquier nota a continuación.",
    name: "Nombre",
    namePlaceholder: "Tu nombre completo",
    email: "Correo electrónico",
    emailPlaceholder: "tu@correo.com",
    phone: "Teléfono",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "Asunto",
    subjectPlaceholder: "Selecciona un tema",
    subjectEngine: "Consulta de motor",
    subjectTransmission: "Consulta de transmisión",
    subjectBody: "Consulta de pieza de carrocería",
    subjectGeneral: "Consulta general",
    subjectSpecialOrder: "Pedido especial / Solicitud de pieza",
    part: "Pieza / artículo consultado",
    partPlaceholder: "p. ej. Motor – Toyota HiLux 2018",
    vehicle: "Vehículo (Marca, Modelo y Año)",
    vehiclePlaceholder: "p. ej. Toyota HiLux 2018",
    notes: "Notas",
    notesPlaceholder: "Cuéntanos qué pieza buscas...",
    maxChars: "Máx. 500 caracteres",
    partPhoto: "Foto de la pieza (opcional)",
    partPhotoHint: "JPG, PNG o WebP, hasta 8 MB. Nos ayuda a identificar la pieza exacta más rápido.",
    choosePhoto: "Elegir foto",
    removePhoto: "Eliminar foto",
    photoInvalid: "Elige un archivo de imagen (JPG, PNG o WebP).",
    photoTooLarge: "Esa imagen es demasiado grande. Elige una de menos de 8 MB.",
    success: "¡Gracias por tu consulta! Te responderemos en breve.",
    sending: "Enviando...",
    send: "Enviar consulta",
    details: "Nuestros datos",
    addressLabel: "Dirección",
    phoneLabel: "Teléfono",
    emailLabel: "Correo electrónico",
    hoursLabel: "Horario de apertura",
    sat: "Sáb: Con cita previa",
  },
  detail: {
    home: "Inicio",
    photos: "Fotos",
    specifications: "Especificaciones",
    make: "Marca",
    model: "Modelo",
    year: "Año",
    fitment: "Compatibilidad",
    condition: "Estado",
    warranty: "Garantía",
    notFound: "Esta pieza no se pudo encontrar. Puede que se haya vendido o retirado.",
    backHome: "Volver al inicio",
    backToList: "Volver a la lista",
  },
};